import Navbar from "@/pages/home/components/Navbar";
import Hero from "@/pages/home/components/Hero";
import AboutSection from "@/pages/home/components/AboutSection";
import Features from "@/pages/home/components/Features";
import StatusSection from "@/pages/home/components/StatusSection";
import RecoverSection from "@/pages/home/components/RecoverSection";
import BookmarkSection from "@/pages/home/components/BookmarkSection";
import FaqSection from "@/pages/home/components/FaqSection";
import SafetySection from "@/pages/home/components/SafetySection";
import Footer from "@/pages/home/components/Footer";

export default function Home() {
  return (
    <div id="top" className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Navbar />
      <main>
        <Hero />
        <AboutSection />
        <Features />
        <StatusSection />
        <RecoverSection />
        <BookmarkSection />
        <FaqSection />
        <SafetySection />
      </main>
      <Footer />
    </div>
  );
}